import { hashQueryKey } from "react-query";

import type { FetcherQueryKey } from "./query.types";
import { queryClient } from "./query.helpers";

type NewOnQueryRemove = {
  queryKey: FetcherQueryKey<any>;
  onRemove: (data: any) => void;
};
type OnQueryRemove = {
  queryKeyHash: string;
  onRemove: (data: any) => void;
};

const registry = new Map<string, OnQueryRemove>();

const queryCache = queryClient.getQueryCache();
queryCache.subscribe((event) => {
  if (event && event.type === "queryRemoved") {
    const queryKeyHash = event.query.queryHash;
    const onQueryRemove = registry.get(queryKeyHash);
    const data = event.query.state.data;
    if (onQueryRemove && data !== undefined) {
      registry.delete(queryKeyHash);
      onQueryRemove.onRemove(data);
    }
  }
});

export const registerOnQueryRemoveCallback = (
  onQueryRemove: NewOnQueryRemove,
) => {
  const queryKeyHash = hashQueryKey(onQueryRemove.queryKey);
  if (!registry.has(queryKeyHash)) {
    registry.set(queryKeyHash, {
      queryKeyHash,
      onRemove: onQueryRemove.onRemove,
    });
  }
};
